__turbopack_context__.v({
  "btn-group": "ChangeProductDrawer-module-scss-module__mhvHta__btn-group",
  "form": "ChangeProductDrawer-module-scss-module__mhvHta__form",
  "list": "ChangeProductDrawer-module-scss-module__mhvHta__list",
  "perks": "ChangeProductDrawer-module-scss-module__mhvHta__perks",
  "skeleton": "ChangeProductDrawer-module-scss-module__mhvHta__skeleton",
  "skeleton-loading": "ChangeProductDrawer-module-scss-module__mhvHta__skeleton-loading",
});
